import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import ExistingRoles from './existingRoles';
import FeatureList from './featureList'

class RoleManagement extends React.Component {
  render() {
    return (
		<div className='role-management-container'>
      <ExistingRoles className='existing-roles'/>
      	{(() => {
      		if (this.props.roleManagement.showFeatures) {
      			return (
      				<div className='animated fadeIn'>
        				<FeatureList
        					key='features-list'
        					className='feature-list'
        					master_features_list={this.props.user.features}/>
      				</div>
      			)
      		}
      		else {
      			return (
      				<div className='row'>
      					<div className='col-md-4'>
          				<div
          					id='select-role-alert'
          					className='alert alert-info'>
	          				<h4>Select a role to view and/or edit available features</h4>
	          			</div>
	          		</div>
          		</div>
        		);
      		}
      	})()}
    </div>
    );
  }
}

function mapStateToProps({roleManagement, users, features}) {
	return {
		roleManagement,
		user : users.user,
		features
	}
}

export default connect(mapStateToProps)(RoleManagement)



// WEBPACK FOOTER //
// ./src/browser/components/roleManagement/roleManagementContainer.js